<template>
    <div class="col-sm-4" v-if="can('locations.index','stations.index','routes.index','schedules.index')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Schedule")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/locations" tag="li" v-if="can('locations.index')">
                        <a href="#" title="">{{i18n("Areas")}}</a>
                    </router-link>
                    <router-link to="/stations" tag="li" v-if="can('stations.index')">
                        <a href="#" title="">{{i18n("Bus terminals")}}</a>
                    </router-link>
                    <router-link to="/routes" tag="li" v-if="can('routes.index')">
                        <a href="#" title="">{{i18n("Routes")}}</a>
                    </router-link>
                    <router-link to="/schedules" tag="li" v-if="can('schedules.index')">
                        <a href="#" title="">{{i18n("Schedule trips")}}</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SchedulesCard"
    }
</script>

<style scoped>

</style>
